import { CloudinaryConfig } from "@cloudinary/url-gen";
import const_env from "../app/constants/env";

const Cloudinary = new CloudinaryConfig({
  cloud: {
    cloudName: const_env.CLOUDINARY_CLOUD_NAME,
  }
})
export default Cloudinary;